
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document
	.querySelectorAll("body:not(.is-admin) .info__slider")
	.forEach(function (item) {
		let slider = new Swiper((item), {
			slidesPerView: '1.25',
			spaceBetween: 10,
			setWrapperSize:true,
			breakpoints: {
				500: {
					slidesPerView: 1.60,
					spaceBetween: 10,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 10,
				},
				1400: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
			},
			pagination: {
				el: item.querySelector(".info__slider-pagi"),
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					return current.toString().padStart(2, "0") + '/' + ((total ).toString().padStart(2, "0") );
				}
			},
			 navigation: {
				nextEl: item.querySelector(".swiper-next"),
				prevEl: item.querySelector(".swiper-prev"),
			},
		});
	});
	document
	.querySelectorAll("body:not(.is-admin) .info__slider-2")
	.forEach(function (item) {
		new Swiper((item), {
			slidesPerView: 1,
			spaceBetween: 10,
			setWrapperSize:true,
			breakpoints: {
				500: {
					slidesPerView: 1.25,
					spaceBetween: 10,
				},
				1024: {
					spaceBetween: 10,
					slidesPerView: 1.5,
				},
				1400: {
					spaceBetween: 16,
					slidesPerView: 1.5
				},
			},
			pagination: {
				el: item.querySelector(".info__slider-pagi"),
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					return current.toString().padStart(2, "0") + '/' + ((total ).toString().padStart(2, "0") );
				}
			},
			 navigation: {
				nextEl: item.querySelector(".swiper-next"),
				prevEl: item.querySelector(".swiper-prev"),
			},
		});
	});
	document
	.querySelectorAll("body:not(.is-admin) .info__slider-4")
	.forEach(function (item) {
		let slider = new Swiper((item), {
			slidesPerView: 'auto',
			spaceBetween: 10,
			setWrapperSize:true,
			freemode:true,
			centeredSlides:true,
			loop:true,
			mousewheel: {
				forceToAxis: true,
			},
			breakpoints: {
				500: {
					spaceBetween: 10,
					centeredSlides:true,
				},
				1024: {
					spaceBetween: 10,
					slidesPerView: 4,
					centeredSlides:false,
				},
				1400: {
					spaceBetween: 16,
					centeredSlides:false,
					slidesPerView: 4,
				},
			},
			pagination: {
				el: item.querySelector(".info__slider-pagi"),
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					return current.toString().padStart(2, "0") + '/' + ((total ).toString().padStart(2, "0") );
				}
			},
			 navigation: {
				nextEl: item.querySelector(".swiper-next"),
				prevEl: item.querySelector(".swiper-prev"),
			},
		});
	});
